import type { Visit } from "@/data/queries";

// One vocabulary for a visit's state everywhere (list, hub, home, map).
export type VisitStatus = "in_progress" | "processing" | "failed" | "review" | "signed" | "ready";

export function visitStatus(v: Pick<Visit, "completed_at" | "processing_state" | "report_id" | "report_approved_at">): VisitStatus {
  if (!v.completed_at) return "in_progress";
  if (v.processing_state === "failed") return "failed";
  if (v.processing_state && v.processing_state !== "completed") return "processing";
  if (v.report_approved_at) return "signed";
  if (v.report_id) return "review";
  return "ready";
}

export const STATUS_META: Record<VisitStatus, { label: string; badge: "success" | "info" | "warning" | "error" | "neutral" | "primary"; hint: string }> = {
  in_progress: { label: "In progress", badge: "info", hint: "Visit still open on a device" },
  processing: { label: "Processing", badge: "warning", hint: "AI pipeline running" },
  failed: { label: "Needs attention", badge: "error", hint: "Processing failed" },
  review: { label: "Needs review", badge: "primary", hint: "Report drafted, not signed" },
  signed: { label: "Signed", badge: "success", hint: "Report approved" },
  ready: { label: "Ready", badge: "neutral", hint: "Synced and processed" },
};
